<template>
  <page-section>
    <rest-list-editable
      :payload="fetchEndpoint"
      ref="rest-list-editable"
      :add-endpoint="rowAddEndpoint"
      :update-endpoint="rowUpdateEndpoint"
    >
      <rest-list-column
        prop="id"
        :title="$t('Integrations_PromotionsList_Field_Id')"
        :width="100"
      />

      <rest-list-column
        prop="external_id"
        :title="$t('Integrations_PromotionsList_Field_External_Id')"
        :editable="true"
        :width="200"
      />

      <rest-list-column
        prop="language_code"
        title="Language Code"
        :width="150"
      />

      <rest-list-column
        prop="name"
        :title="$t('Integrations_PromotionsList_Field_Name')"
        :editable="true"
      />

      <rest-list-column
        prop="description"
        :title="$t('Integrations_PromotionsList_Field_Description')"
        :editable="true"
      />

      <rest-list-column
        prop="metadata"
        :title="$t('Integrations_PromotionsList_Field_Metadata')"
        :editable="true"
        :sortable="false"
        :width="200"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="
              showDataPopup(
                $t('Integrations_PromotionsList_Field_Metadata'),
                JSON.stringify(scope.row.metadata)
              )
            "
            v-if="scope.row.metadata"
          >
            {{ $t('Integrations_PromotionsList_Field_Metadata') }}
            <el-icon name="view" />
          </el-button>
          <span v-else>-</span>
        </template>
      </rest-list-column>
    </rest-list-editable>

    <el-dialog
      :title="dataPopup"
      :visible="dataPopup"
      :modal="false"
      :modal-append-to-body="false"
      :before-close="closeDataPopup"
    >
      <vue-json-pretty :data="jsonData" class="json-wrapper"></vue-json-pretty>
    </el-dialog>
  </page-section>
</template>

<script>
import RestListEditable from '@/common/components/rest/RestListEditable'
import RestListColumn from '@/common/components/rest/RestListColumn'
import { projectEndpoint } from '@/core/helpers'
import PageSection from '@/common/components/page/PageSection'
import VueJsonPretty from 'vue-json-pretty'

export default {
  name: 'IntegrationCouponsetsTable',

  components: {
    PageSection,
    RestListEditable,
    RestListColumn,
    VueJsonPretty
  },

  props: {
    integrationId: {
      type: Number
    },

    integrationType: {
      type: String
    }
  },

  data() {
    return {
      dataPopup: null,
      jsonData: null
    }
  },

  computed: {
    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `couponsets`,
        params: {
          sort: '-id',
          integration_id: this.integrationId
        }
      })
    },

    rowAddEndpoint() {
      return projectEndpoint({
        method: 'post',
        url: `promotions`
      })
    }
  },

  methods: {
    rowDeleteEndpoint(row) {
      return projectEndpoint({
        method: 'delete',
        url: `promotions/${row.id}`
      })
    },

    rowUpdateEndpoint(row) {
      return projectEndpoint({
        method: 'patch',
        url: `promotions/${row.id}`
      })
    },

    showDataPopup(title, json) {
      this.jsonData = JSON.parse(json)
      this.dataPopup = title
    },

    closeDataPopup() {
      this.dataPopup = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/integrations/components/IntegrationCouponsetsTable.vue